<template>
  <div class="home-tasks" v-if="loaded">
    <PageHeader>
      <div class="heading">
        <h1>
          What's New
        </h1>
      </div>

      <div class="header-actions">
        <Btn tertiary tooltip="Thank you!">
          <a
            v-if="isWhiteLabel"
            href="mailto:jack@new-website.co.uk?subject=Admin%20Panel%20Feedback"
            target="_blank"
          >
            Give Feedback
          </a>
          <a
            v-else
            href="mailto:support@pagemakerpro.com?subject=PageMakerPro%20Feedback">
            Give Feedback
          </a>
        </Btn>
      </div>
    </PageHeader>

    <div class="page-columns">
      <div class="col main">
        <div class="page-content">
          <section>
            <Trello />
          </section>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <p>
              The <strong>What's New</strong> section is regularly updated to
              keep you in the loop on what we're currently working on.
            </p>
            <p>
              While some features can be new and exciting, they may not yet be 100% stable. Their code and components are complete for the most part, but there may still be some tweaks required that you can help bring to our attention.
            </p>
          </div>
        </PageSummary>
      </div>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import {mapState} from 'vuex'

import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'
import Btn from '@/components/Btn'
import Trello from '@/components/Trello'

export default {
  name: 'whats-new',

  mixins: [page],

  data() {
    return {
      title: 'Tasks',
      loaded: false
    }
  },

  computed: {
    ...mapState(['currentUser']),

    accountRoute() {
      const currentUser = this.currentUser

      if (currentUser && currentUser.company_id) {
        return {
          name: 'company-user',
          params: {companyId: currentUser.company_id, userId: currentUser.id}
        }
      } else {
        return {
          name: 'user',
          params: {userId: currentUser.id}
        }
      }
    },

    isWhiteLabel() {
      return this.$store.state.whiteLabel
    }
  },

  mounted() {
    let notLoggedIn = Object.keys(this.currentUser).length === 0

    if (notLoggedIn) {
      this.$router.push({name: 'login'})
    } else {
      this.loaded = true
    }
  },

  components: {
    PageHeader,
    PageSummary,
    Btn,
    Trello
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.home-tasks
  @extend %page
</style>
